import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import "./style/Sidebar.css";

const Sidebar = ({ onLogout }) => {
  const navigate = useNavigate();
  const auth = getAuth();
  const location = useLocation();

  const handleLogout = async () => {
    await signOut(auth);
    onLogout();
    navigate("/");
  };

  return (
    <div className="sidebar">
      <img src="/neoslide-logo.png" alt="NeoSlide Logo" width={100} />
      <img src="/neoslide-logo-2.png" alt="NeoSlide Logo" width={150} />
      <h2>Admin Panel</h2>
      <nav>
        <ul>
          <li>
            <Link
              to="/workspaces"
              className={location.pathname === "/workspaces" ? "active" : ""}
            >
              Workspaces
            </Link>
          </li>
          <li>
            <Link
              to="/users"
              className={location.pathname === "/users" ? "active" : ""}
            >
              Users
            </Link>
          </li>
          <li>
            <Link
              to="/addons"
              className={location.pathname === "/addons" ? "active" : ""}
            >
              Add Ons
            </Link>
          </li>
          <li>
            <Link
              to="/app"
              className={location.pathname === "/app" ? "active" : ""}
            >
              App
            </Link>
          </li>
          <li>
            <Link
              to="/devices"
              className={location.pathname === "/devices" ? "active" : ""}
            >
              Devices
            </Link>
          </li>
          <li>
            <Link
              to="/pending-requests"
              className={location.pathname === "/pending-requests" ? "active" : ""}
            >
              Pending Requests
            </Link>
          </li>
        </ul>
      </nav>
      <button className="logout-button" onClick={handleLogout}>
        Logout
      </button>
      <div className="copyright">
        Copyright © 2025 blackboxsolutions.mk
      </div>
    </div>
  );
};

export default Sidebar;
